<template>
  <div>
    <NavBarComponent  />
    <div class="container mt-4">
    <router-view />
    </div>
  </div>
</template>

<script>
import NavBarComponent  from './components/NavBarComponent.vue';
export default {
  components: { NavBarComponent  },
};
</script>
